import React, { useEffect, useState } from 'react';
import styles from './StatCard.module.css';
import { FormControl, MenuItem, OutlinedInput, Select } from '@mui/material';
import { Popover, ActionIcon, Text } from '@mantine/core';
import { IconInfoCircleFilled } from '@tabler/icons-react';

export default function StatCardSingleSelect({
    options,
    selectedOption,
    handleChange,
    title,
    tooltip
}) {
    const [currentSelectedOption, setCurrentSelectedOption] = useState(selectedOption ?? '');
    const [currentOptions, setCurrentOptions] = useState(options ?? []);

    const handleSelectChange = (event) => {
        setCurrentSelectedOption(event.target.value);
        handleChange(event.target.value);
    };

    useEffect(() => {
        setCurrentSelectedOption(selectedOption ?? '');
    }, [selectedOption]);

    useEffect(() => {
        setCurrentOptions(options ?? []);
    }, [options]);

    useEffect(() => {
        console.log('Selected Option:', currentSelectedOption);
    }, [currentSelectedOption]);

    useEffect(() => {
        console.log('Options:', currentOptions);
    }, [currentOptions]);

    return (
        <div className={`${styles.cardSelect} mt-8`}>
            <FormControl fullWidth sx={{ rowGap: '8px' }}>
                <Popover
                    width={280}
                    shadow="md"
                    withArrow
                    withinPortal
                    portalProps={{ target: '#root' }}
                >
                    <Popover.Target>
                        <h1>
                            <span style={{ position: 'relative' }}>
                                {title}
                                <ActionIcon
                                    style={{ pointerEvents: 'all' }}
                                    variant="transparent"
                                    size="xs"
                                    radius="xl"
                                    aria-label="Settings"
                                    className="statcardTooltip"
                                >
                                    <IconInfoCircleFilled
                                        style={{ width: '85%', height: '85%', color: '#FFF' }}
                                        stroke={1.5}
                                    />
                                </ActionIcon>
                            </span>
                        </h1>
                    </Popover.Target>
                    {tooltip && (
                        <Popover.Dropdown className="overflow-auto z-50">
                            <Text size="sm">{tooltip}</Text>
                        </Popover.Dropdown>
                    )}
                </Popover>
                <Select
                    displayEmpty
                    value={currentSelectedOption}
                    onChange={handleSelectChange}
                    input={<OutlinedInput />}
                    className={styles.select}
                >
                    <MenuItem disabled value="">
                        <em>{title}</em>
                    </MenuItem>
                    {currentOptions?.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
